// Module
var code = "<div class=\"card\"> <div class=\"card-content\"> <p><b>Email:</b> :userEmail :tagCurrentUser</p> <p><b>Name:</b> :userName</p> <p><span class=\"tags\"><b>Rights:</b>:userRights</span></p> </div> </div> ";
// Exports
export default code;